import React, { memo } from 'react'
import { Table as AntdTable, TableProps } from 'antd'

function Table<RecordType extends object>(props: TableProps<RecordType>) {
	return <AntdTable {...props} scroll={{ x: 'max-content' }} />
}

export default memo(Table) as typeof Table
